import { render, staticRenderFns } from "./step2.vue?vue&type=template&id=7388c75a&scoped=true"
import script from "./step2.vue?vue&type=script&lang=js"
export * from "./step2.vue?vue&type=script&lang=js"
import style0 from "./step2.vue?vue&type=style&index=0&id=7388c75a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7388c75a",
  null
  
)

export default component.exports